// @ts-nocheck
import { faKey, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import AuthSocialButtons from 'components/common/AuthSocialButtons';
import { Col, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast, Zoom } from 'react-toastify';
import axios from 'axios';
import { getCookie, isAuth, authenticate } from 'helpers/helpers';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const SignInForm = ({ layout }: { layout: 'simple' | 'card' | 'split' }) => {
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const setEmailHandler = e => {
    setEmail(e.target.value);
  };

  const setPasswordHandler = e => {
    setPassword(e.target.value);
  };

  const clickSubmit = event => {
    event.preventDefault();

    axios({
      method: 'POST',
      url: `${process.env.REACT_APP_AUTH_API}/signin`,
      data: { email, password }
    })
      .then(response => {
        if (response.status === 200) {
          toast.success('Anmeldung erfolgreich', {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'dark',
            transition: Zoom
          });

          setTimeout(() => {
            navigate('/primedeco/product-table');
          }, 2000);

          authenticate(response, () => {});
        } else if (response.status === 201) {
          toast.error('E-Mail und Passwort stimmen nicht überein', {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'dark',
            transition: Zoom
          });
        } else {
          toast.error('Keine Verbindung zum Server', {
            toastId: 'custom-id-yes',
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
            transition: Zoom
          });
        }
      })
      .catch(error => {
        toast.error('Catch: Keine Verbindung zum Server', {
          toastId: 'custom-id-yes',
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'colored',
          transition: Zoom
        });
      });
  };

  return (
    <>
      <div className="text-center mb-7">
        <h3 className="text-body-highlight">Anmelden</h3>
        <p className="text-body-tertiary">PRIMEDECO for the WORLD</p>
      </div>

      <div className="position-relative">
        <hr className="bg-body-secondary mt-5 mb-4" />
        <div className="divider-content-center">Let's get down to business</div>
      </div>
      <Form.Group className="mb-3 text-start">
        <Form.Label htmlFor="email">Email addresse</Form.Label>
        <div className="form-icon-container">
          <Form.Control
            id="email"
            type="email"
            className="form-icon-input"
            placeholder="name@example.com"
            onChange={setEmailHandler}
          />
          <FontAwesomeIcon icon={faUser} className="text-body fs-9 form-icon" />
        </div>
      </Form.Group>
      <Form.Group className="mb-3 text-start">
        <Form.Label htmlFor="password">Passwort</Form.Label>
        <div className="form-icon-container">
          <Form.Control
            id="password"
            type="password"
            className="form-icon-input"
            placeholder="Password"
            onChange={setPasswordHandler}
          />
          <FontAwesomeIcon icon={faKey} className="text-body fs-9 form-icon" />
        </div>
      </Form.Group>
      {/* <Row className="flex-between-center mb-7">
        <Col xs="auto"></Col>
        <Col xs="auto">
          <Link
            to={`/pages/authentication/${layout}/forgot-password`}
            className="fs-9 fw-semibold"
          >
            Passwort vergessen?
          </Link>
        </Col>
      </Row> */}
      <Button onClick={clickSubmit} variant="primary" className="w-100 mb-3">
        Anmelden
      </Button>
      <div className="text-center">
        <Link to={`/auth/sign-up`} className="fs-9 fw-bold">
          Benutzer registrieren
        </Link>
      </div>
    </>
  );
};

export default SignInForm;
